import React from 'react'
import styled from 'styled-components'

export default function SoftSkills() {
  return (
    <DIV>
            <h2 className='fs-2 fw-bold text-center my-5 pt-5'>Soft <span className='themeColor'>Skills</span></h2>
        <div class="container mt-3 mb-5">


  <div class="card-left border" data-aos="fade-up">
    <div class="card-image">
      <img src='https://kissflow.com/hubfs/What-is-Collaboration-768x407.jpg'/>
    </div>
    <div class="card-text">
        <h5 className='fw-bold'>Teamwork</h5>
      <p>Contributed in 4+ Collaborative Projects</p>
    </div>
  </div>


  <div class="card-top border" data-aos="fade-up">
    <div class="card-image">
      <img src='https://theincmagazine.com/wp-content/uploads/2021/10/practicing_the_art_of_leadership-header.png'/>
    </div>
    <div class="card-text">
    <h5 className='fw-bold'>Leadership</h5>
      <p>Guiding Innovation in Full Stack Web Development</p>
    </div>
  </div>


  <div class="card-right border" data-aos="fade-up">
    <div class="card-image">
      <img src='https://globisinsights.com/wp-content/uploads/2023/01/5-Ways-to-Improve-Your-Active-Listening-Skills-746x420.jpg'/>
    </div>
    <div class="card-text">
    <h5 className='fw-bold'>Active Listener</h5>
      <p>The Art of Listening: An Active Leader's Guide</p>
    </div>
  </div>


  <div class="card-right border" data-aos="fade-up">
    <div class="card-image">
    <img src='https://assets-global.website-files.com/61766c42e8e50c99a04fbd4b/62bf38493c10d5bd2a6f5bec_shutterstock_1151217977.jpg'/>
    </div>
    <div class="card-text">
        <h5 className='fw-bold'>Communication</h5>
      <p>Unlocking Success with Strong Communication Skills</p>
    </div>
  </div>

  
  <div class="card-left border" data-aos="fade-up">
    <div class="card-image">
      <img src='https://apolloafterschool.com/wp-content/uploads/2022/09/developing-critical-thinking-skills-in-kids.png'/>
    </div>
    <div class="card-text">
    <h5 className='fw-bold'>Critical Thinking</h5>
      <p>Critical Thinking: A Path to Problem Solving</p>
    </div>
  </div>
  {/* <div class="card-top">
    <div class="card-image">
      <img src='https://secure.caes.uga.edu/extension/publications/images/thumbnail-pub-images/C1042-social-Preview-Image.png'/>
    </div>
    <div class="card-text">
    <h5 className='fw-bold'>Time Management</h5>
      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
    </div>
  </div>
  <div class="card-bottom">
    <div class="card-image">
      <img src='https://www.aihr.com/wp-content/uploads/Creativity-data-featured.jpg'/>
    </div>
    <div class="card-text">
    <h5 className='fw-bold'>Creativity</h5>
      <p>Ut eu diam at pede suscipit sodales.</p>
    </div>
  </div>
  <div class="card-left">
    <div class="card-image">
    <img src='https://www.careeraddict.com/uploads/article/61083/problem-solving-skills.png'/>
    </div>
    <div class="card-text">
    <h5 className='fw-bold'>Problem-Solving</h5>
      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
    </div>
  </div>
  <div class="card-bottom">
    <div class="card-image">
      <img src='https://assets.website-files.com/634681057b887c6f4830fae2/6367ddb19488542def3d98f8_6259f5f38337c78e782688ff_multitasking.png'/>
    </div>
    <div class="card-text">
    <h5 className='fw-bold'>Multitasking</h5>
      <p>Quisque cursus, metus vitae pharetra auctor.</p>
    </div>
  </div>
  <div class="card-right">
    <div class="card-image">
      <img src='https://cdn3.careeraddict.com/uploads/article/60117/medium-break-room-why-motivation-important.jpg'/>
    </div>
    <div class="card-text">
    <h5 className='fw-bold'>Self-Motivated</h5>
      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
    </div>
  </div> */}

  {/* <div class="card-left">
    <div class="card-image">
      <img src='https://apolloafterschool.com/wp-content/uploads/2022/09/developing-critical-thinking-skills-in-kids.png'/>
    </div>
    <div class="card-text">
    <h5 className='fw-bold'>Critical Thinking</h5>
      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
    </div>
  </div>
  <div class="card-left">
    <div class="card-image">
      <img src='https://res.cloudinary.com/people-matters/image/upload/fl_immutable_cache,w_624,h_351,q_auto,f_auto/v1558635029/1558635027.jpg'/>
    </div>
    <div class="card-text">
    <h5 className='fw-bold'>Continuous Learning</h5>
      <p>Ut eu diam at pede suscipit sodales.</p>
    </div>
  </div>
  <div class="card-top">
    <div class="card-image">
      <img src='https://res.cloudinary.com/people-matters/image/upload/q_auto,f_auto/v1598495184/1598495183.jpg'/>
    </div>
    <div class="card-text">
    <h5 className='fw-bold'>Resilience</h5>
      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
    </div>
  </div>
  <div class="card-bottom">
    <div class="card-image">
      <img src='https://hsiassetstorage.sfo2.digitaloceanspaces.com/transforms/blogimages/198080/Mentorship-Program-Template-HSI-Blog_d4bd353bac6a5f3a10ab94d9650d3531.jpg'/>
    </div>
    <div class="card-text">
    <h5 className='fw-bold'>Mentorship</h5>
      <p>Quisque cursus, metus vitae pharetra auctor.</p>
    </div>
  </div>
  <div class="card-top">
    <div class="card-image">
      <img src='https://t3.ftcdn.net/jpg/04/63/80/98/360_F_463809882_zbFUw3ZgAJRDIa4gFog0mgqlCOnA2Umv.jpg'/>
    </div>
    <div class="card-text">
    <h5 className='fw-bold'>Adaptability</h5>
      <p>Quisque cursus, metus vitae pharetra auctor.</p>
    </div>
  </div>
  <div class="card-bottom">
    <div class="card-image">
      <img src='https://blog.faradars.org/wp-content/uploads/2020/04/fast-learning-cover.jpg'/>
    </div>
    <div class="card-text">
    <h5 className='fw-bold'>Quick learner</h5>
      <p>Donec lacus nunc, viverra nec, blandit vel, egestas et, augue.</p>
    </div>
  </div>
  <div class="card-right">
    <div class="card-image">
      <img src='https://media.licdn.com/dms/image/D4E12AQEvu9bR-l86bw/article-cover_image-shrink_720_1280/0/1680637353177?e=2147483647&v=beta&t=Oaj9iio43HVn_cLZDbazINK1AAa0uBGBnKn7urCjq_4'/>
    </div>
    <div class="card-text">
    <h5 className='fw-bold'>Presentation Skill</h5>
      <p>Ut eu diam at pede suscipit sodales.</p>
    </div>
  </div> */}
</div>

    </DIV>
  )
}


const DIV = styled.div`
    body {
	 margin: 23px;
	 font-family: "Trebuchet MS", sans-serif;
	 font-size: 15.5px;
}
 * {
	 box-sizing: border-box;
}
 .container {
	 width: 100%;
	 display: grid;
	 grid-template-columns: repeat(auto-fit, minmax(200px, 200px));
	 grid-auto-rows: 200px;
	 grid-auto-flow: row dense;
	 grid-gap: 23px;
	 justify-content: center;
}
 .card-top, .card-right, .card-bottom, .card-left {
	 display: flex;
	 flex-wrap: nowrap;
	 height: 100%;
	 width: 100%;
	 border-radius: 95.2380952381px;
	 box-shadow: 0px 3px 9px 1px rgba(0, 10, 20, 0.2);
   /* border: 1px solid white; */
}
 .card-top {
	 flex-direction: column;
	 grid-column: auto / span 1;
	 grid-row: auto / span 2;
}
 .card-right {
	 flex-direction: row-reverse;
	 grid-column: auto / span 2;
	 grid-row: auto / span 1;
}
 .card-bottom {
	 flex-direction: column-reverse;
	 grid-column: auto / span 1;
	 grid-row: auto / span 2;
}
 .card-left {
	 flex-direction: row;
	 grid-column: auto / span 2;
	 grid-row: auto / span 1;
}
 .card-image {
	 display: flex;
}
 .card-top .card-image, .card-bottom .card-image {
	 height: 50%;
	 width: 100%;
}
 .card-left .card-image, .card-right .card-image {
	 height: 100%;
	 width: 50%;
}
 .card-image img {
	 width: 100%;
	 object-fit: cover;
}
 .card-top img {
	 border-radius: 95.2380952381px 95.2380952381px 0 0;
}
 .card-right img {
	 border-radius: 0 95.2380952381px 95.2380952381px 0;
}
 .card-bottom img {
	 border-radius: 0 0 95.2380952381px 95.2380952381px;
}
 .card-left img {
	 border-radius: 95.2380952381px 0 0 95.2380952381px;
}
 .card-text {
	 align-self: center;
	 padding: 23px;
}
 .card-top .card-text {
	 height: auto;
	 width: auto;
	 padding-bottom: 36.8px;
}
 .card-right .card-text {
	 height: auto;
	 width: 50%;
	 padding-left: 36.8px;
}
 .card-bottom .card-text {
	 height: auto;
	 width: auto;
	 padding-top: 36.8px;
}
 .card-left .card-text {
	 height: auto;
	 width: 50%;
	 padding-right: 36.8px;
}
 .card-text p {
	 margin: 0;
	 line-height: 1.35em;
	 /* color: #345; */
}
 @media (max-width: 500px) {
	 .card-top {
		 flex-direction: row;
		 grid-column: auto / span 2;
		 grid-row: auto / span 1;
	}
	 .card-bottom {
		 flex-direction: row-reverse;
		 grid-column: auto / span 2;
		 grid-row: auto / span 1;
	}
	 .card-top .card-image, .card-bottom .card-image {
		 height: 100%;
		 width: 50%;
	}
	 .card-top img {
		 border-radius: 95.2380952381px 0 0 95.2380952381px;
	}
	 .card-bottom img {
		 border-radius: 0 95.2380952381px 95.2380952381px 0;
	}
	 .card-top .card-text {
		 height: auto;
		 width: 50%;
		 padding-right: 36.8px;
	}
	 .card-bottom .card-text {
		 height: auto;
		 width: 50%;
		 padding-left: 36.8px;
	}
}
 @media (max-width: 400px) {
	 .card-image {
		 width: 38% !important;
	}
	 .card-text {
		 width: 62% !important;
	}
}
 
`